'use client';

import * as React from 'react';
export const CalendarGridTimeEventContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridTimeEventContext.displayName = "CalendarGridTimeEventContext";
export function useCalendarGridTimeEventContext() {
  const context = React.useContext(CalendarGridTimeEventContext);
  if (context === undefined) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: `CalendarGridTimeEventContext` is missing. CalendarGrid TimeEvent parts must be placed within <CalendarGrid.TimeEvent />.');
  }
  return context;
}